import React, { useState } from "react";
import { Col } from "react-bootstrap";
import { DownOutlined, PaperClipOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import ReactLoading from "react-loading";
import { useReactToPrint } from "react-to-print";


import "./Buttons.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
function BtnPrintV2({ 
  label, 
  size, 
  divId, 
  fileName,
  paperType 
}) {
  const [isClicked, setIsClicked] = useState(false);
  const items = [
    {
      label: 'A5',
      key: 'a5',
      icon: <PaperClipOutlined />,
    },
    {
      label: 'A4',
      key: 'a4',
      icon: <PaperClipOutlined />,
    },
    {
      label: 'Letter',
      key: 'letter',
      icon: <PaperClipOutlined />,
    },
    {
      label: 'Legal',
      key: 'legal',
      icon: <PaperClipOutlined />,
    },
  ];
  const reactToPrint = useReactToPrint({
    content: () => divId.current,
  });
  
  // const handlePrint = async (e) => {
  //   setIsClicked(true);
  //   const input = divId.current;
  //   const padding = 0;
  
  //   html2canvas(input, { backgroundColor: null }).then((canvas) => {
  //       const imgData = canvas.toDataURL("image/png");
  //       const pdf = new jsPDF('p', 'mm', e?.key, true);
  //       const pdfWidth = pdf.internal.pageSize.getWidth() - 2 * padding;
  //       const pdfHeight = pdf.internal.pageSize.getHeight() - 2 * padding;
  //       const imgWidth = canvas.width;
  //       const imgHeight = canvas.height;
  //       const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
  //       const imgX = (pdfWidth - imgWidth * ratio) / 2;
  //       const imgY = 5;
  
  //       // **Add Bottom Rectangles with Gaps**
  //       const rectHeight = 8; // Height of the rectangles
  //       const gapSize = 2; // Size of the gaps
  //       const rectWidth = (pdfWidth / 2) - (gapSize / 2); // Adjusted width to account for middle gap
  
  //       // **Left Sky-Blue Rectangle**
  //       pdf.setFillColor(102, 240, 242); // Skyblue color
  //       pdf.rect(gapSize, pdfHeight - rectHeight, rectWidth - gapSize, rectHeight, "F");
  
  //       // **Right Blue Rectangle**
  //       pdf.setFillColor(0, 102, 204); // Blue color
  //       const rectX = pdfWidth / 2 + (gapSize / 2);
  //       const rectY = pdfHeight - rectHeight;
  //       pdf.rect(rectX, rectY, rectWidth, rectHeight, "F");
  
  //       // **Right-Angled Triangle Above the Blue Rectangle**
  //       const triangleHeight = 125;
  //       const x1 = rectX + rectWidth;  // Rightmost corner of the rectangle (right angle here)
  //       const y1 = rectY;              // Top of the blue rectangle
  //       const x2 = rectX;              // Leftmost corner of the rectangle (base side)
  //       const y2 = rectY;              // Same base level as x1
  //       const x3 = x1;                 // The right angle vertex (same x as x1)
  //       const y3 = rectY - triangleHeight; // Triangle tip (higher than the base)
  
  //       pdf.setFillColor(241, 250, 252); // color of the triangle
  //       pdf.triangle(x1, y1, x2, y2, x3, y3, "F");
  
  //       // Add the content after setting the rectangle and triangle (text, tables, etc.)
  //       pdf.addImage(imgData, "PNG", imgX, imgY, imgWidth * ratio, imgHeight * ratio);
  
  //       // Save pdf file locally
  //       pdf.save(fileName);
  //       pdf.autoPrint();
  //       pdf.output("dataurlnewwindow");
  //     });
  
  //   setIsClicked(false);
  // };
  
  const handlePrint = async (e) => {
    setIsClicked(true);
    const input = divId.current;
    const padding = 0;
    const bottomMargin = 16; // <-- added bottom margin
  
    html2canvas(input, { backgroundColor: null }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", e?.key, true);
  
      const pdfWidth = pdf.internal.pageSize.getWidth() - 2 * padding;
      const pdfHeight = pdf.internal.pageSize.getHeight() - 2 * padding;
  
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
  
      const ratio = pdfWidth / canvasWidth;
      const pageHeightPx = (pdfHeight - bottomMargin) / ratio; // <-- subtract bottom margin here
      let position = 0;
      let pageCount = 0;
  
      while (position < canvasHeight) {
        const canvasSlice = document.createElement("canvas");
        canvasSlice.width = canvasWidth;
        canvasSlice.height = Math.min(pageHeightPx, canvasHeight - position);
  
        const ctx = canvasSlice.getContext("2d");
        ctx.drawImage(
          canvas,
          0,
          position,
          canvasWidth,
          canvasSlice.height,
          0,
          0,
          canvasWidth,
          canvasSlice.height
        );
  
        const imgSliceData = canvasSlice.toDataURL("image/png");
        if (pageCount > 0) pdf.addPage();
  
        const imgX = (pdf.internal.pageSize.getWidth() - canvasSlice.width * ratio) / 2;
        const imgY = 5;
  
        // // Draw rectangles and triangle at the bottom of every page
        // const rectHeight = 8;
        // const gapSize = 2;
        // const fullWidth = pdf.internal.pageSize.getWidth();
        // const fullHeight = pdf.internal.pageSize.getHeight();
        // const rectWidth = (fullWidth / 2) - (gapSize / 2);
  
        // // Left rectangle
        // pdf.setFillColor(102, 240, 242);
        // pdf.rect(gapSize, fullHeight - rectHeight, rectWidth - gapSize, rectHeight, "F");
  
        // // Right rectangle
        // const rectX = fullWidth / 2 + (gapSize / 2);
        // pdf.setFillColor(0, 102, 204);
        // pdf.rect(rectX, fullHeight - rectHeight, rectWidth, rectHeight, "F");
  
        // // Triangle
        // const triangleHeight = 125;
        // const x1 = rectX + rectWidth;
        // const y1 = fullHeight - rectHeight;
        // const x2 = rectX;
        // const y2 = y1;
        // const x3 = x1;
        // const y3 = y1 - triangleHeight;
        // pdf.setFillColor(241, 250, 252);
        // pdf.triangle(x1, y1, x2, y2, x3, y3, "F");
  
        // Add image
        pdf.addImage(
          imgSliceData,
          "PNG",
          imgX,
          imgY,
          canvasSlice.width * ratio,
          canvasSlice.height * ratio
        );
  
        position += pageHeightPx;
        pageCount++;
      }
  
      // pdf.save(fileName);
      // pdf.autoPrint();
      pdf.output("dataurlnewwindow");
      setIsClicked(false);
    });
  };
  
  
  const menuProps = {
    items,
    onClick: (e) => handlePrint(e),
  };

  return (
    <Col>
      {isClicked ? (
        <Button className="action-btn clear loader" size={size}>
          <ReactLoading type={"balls"} height={20} width={25} color="#2d6e5e" />
        </Button>
      ) : (
        <Button 
          className="action-btn clear" 
          size={size} 
          onClick={() => handlePrint(paperType)}
        >
          {label || "Download PDF"}
        </Button>
        // <Dropdown menu={menuProps}>
        //   <Button className="action-btn clear" size={size}>
        //       {label}
        //       <DownOutlined />
        //   </Button>
        // </Dropdown>
      )}
    </Col>
  );
}

export default BtnPrintV2;

